import { render } from "./SearchVesselsModal.vue?vue&type=template&id=52de7186"
import script from "./SearchVesselsModal.vue?vue&type=script&lang=js"
export * from "./SearchVesselsModal.vue?vue&type=script&lang=js"

import "./SearchVesselsModal.vue?vue&type=style&index=0&id=52de7186&lang=css"
script.render = render

export default script